function initPromoTimer() {
  const timerEl = document.querySelector('.promo-bar__timer');
  if (!timerEl) return;

  const endDateStr = timerEl.getAttribute('data-end-date');
  if (!endDateStr) return;

  const endDate = new Date(endDateStr).getTime();
  const daysEl = timerEl.querySelector('.days');
  const hoursEl = timerEl.querySelector('.hours');
  const minutesEl = timerEl.querySelector('.minutes');

  function updateTimer() {
    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance < 0) {
      timerEl.style.display = 'none';
      const separators = document.querySelectorAll('.promo-bar__separator');
      if(separators.length > 0) separators[separators.length - 1].style.display = 'none';
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    if (daysEl.innerText != days) daysEl.innerText = days;
    if (hoursEl.innerText != hours) hoursEl.innerText = hours;
    if (minutesEl.innerText != minutes) minutesEl.innerText = minutes;
  }

  updateTimer(); 
  
  // Clear any existing intervals if the section is reloaded in the customizer
  if (window.promoTimerInterval) clearInterval(window.promoTimerInterval);
  window.promoTimerInterval = setInterval(updateTimer, 60000); 
}

// Run on initial load
document.addEventListener('DOMContentLoaded', initPromoTimer);

// Re-run if the section is updated in the Shopify Customizer
document.addEventListener('shopify:section:load', initPromoTimer);

function initPromoScroll() {
  const promoBar = document.getElementById('PromoBar');
  if (!promoBar) return;

  const scrollThreshold = 300;
  let isSticky = false;

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;

    if (currentScroll > scrollThreshold && !isSticky) {
      promoBar.classList.add('is-sticky');
      isSticky = true;
    } else if (currentScroll <= scrollThreshold && isSticky) {
      promoBar.classList.remove('is-sticky');
      isSticky = false;
    }
  }, { passive: true });
}

// Add this to your existing init sequence
document.addEventListener('DOMContentLoaded', () => {
  initPromoTimer();
  initPromoScroll();
});

document.addEventListener('shopify:section:load', () => {
  initPromoTimer();
  initPromoScroll();
});
